import React, { useEffect, useState } from 'react';
import { TextField, Select, MenuItem, Button, Grid, FormControl, InputLabel } from '@material-ui/core';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { stakingService } from 'services/stakingService';
import { isAddress } from 'ethers/lib/utils.js';
import { toast } from 'react-toastify';
import { getCoinPrice } from 'services/priceService';

const WETH = process.env.REACT_APP_WETH;

export default function StakingAprEdit() {
  const { id } = useParams();
  const [uniswapVersion, setUniswapVersion] = useState('v2');
  const [routerOrQuoterAddress, setRouterOrQuoterAddress] = useState('');
  const [pathToWeth, setPathToWeth] = useState(['', '']);
  const [fees, setFees] = useState(['100']);
  const [loading, setLoading] = useState(false);

  const [pricePreview, setPricePreview] = useState(0);

  const handleSubmit = async () => {
    if (!id) return;
    if (!isAddress(routerOrQuoterAddress)) {
      toast.error('Invalid router or quoter address');
      return;
    }
    const config = {
      uniswapVersion,
      routerOrQuoterAddress,
      pathToWeth,
      fees: fees.map((fee) => parseInt(fee)),
    };

    await stakingService.update(id, { rewardPriceConfig: config });

    toast.success('Updated');
  };

  const handleTry = async () => {
    setLoading(true);
    try {
      const { data: price } = await getCoinPrice(
        uniswapVersion,
        routerOrQuoterAddress,
        pathToWeth,
        fees.map((fee) => parseInt(fee)),
      )

      setPricePreview(price);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  }

  const handleUniswapVersionChange = (event) => {
    setUniswapVersion(event.target.value);
  };

  const handleRouterOrQuoterAddressChange = (event) => {
    setRouterOrQuoterAddress(event.target.value);
  };

  const handlePathToWethChange = (value, index) => {
    const newPathToWeth = [...pathToWeth];
    newPathToWeth[index] = value;
    setPathToWeth(newPathToWeth);
  };

  const handleFeesChange = (value, index) => {
    const newFees = [...fees];
    newFees[index] = value;
    setFees(newFees);
  };

  const handleAddCoin = () => {
    // keep the last coin, which is WETH
    const tmp = pathToWeth.slice(0, -1);
    const weth = pathToWeth[pathToWeth.length - 1];
    setPathToWeth([...tmp, '', weth]);
    setFees([...fees, '100']);
  };

  const handleRemoveCoin = () => {
    if (pathToWeth.length <= 2) {
      alert('Minimum 2 coins');
      return;
    }

    // keep the last coin, which is WETH
    const tmp = pathToWeth.slice(0, -2);
    const weth = pathToWeth[pathToWeth.length - 1];
    setPathToWeth([...tmp, weth]);
    setFees(fees.slice(0, -1));
  }

  const renderPathToWethInputs = () => {
    return pathToWeth.map((path, index) => (
      <TextField
        style={{ marginRight: '10px', minWidth: '400px' }}
        key={index}
        label={index === 0 ? 'Reward Token' : index === pathToWeth.length - 1 ? 'WCRO' : `Token ${index}`}
        disabled={index === pathToWeth.length - 1 || index === 0}
        value={path}
        onChange={(event) => handlePathToWethChange(event.target.value, index)}
      />
    ));
  };

  const renderFeesInputs = () => {
    return <div style={{ display: 'flex', gap: '10px' }}>
      {
        fees.map((fee, index) => (
          <div key={index} style={{ width: '160px' }}>
            <Select
              label="Fee"
              value={fee}
              onChange={(event) => handleFeesChange(event.target.value, index)}
              fullWidth
            >
              <MenuItem value="100">LOWEST</MenuItem>
              <MenuItem value="500">LOW</MenuItem>
              <MenuItem value="3000">MEDIUM</MenuItem>
              <MenuItem value="10000">HIGH</MenuItem>
            </Select>
          </div>
        ))
      }
    </div>;
  };

  useEffect(() => {
    if (id) {
      stakingService.view(id).then(({ data }) => {
        setUniswapVersion(data.rewardPriceConfig?.uniswapVersion || 'v2');
        setRouterOrQuoterAddress(data.rewardPriceConfig?.routerOrQuoterAddress || '');
        setPathToWeth(data.rewardPriceConfig?.pathToWeth || [data.rewardCoin, WETH]);
        setFees(data.rewardPriceConfig?.fees || ['100']); console.log(data.rewardPriceConfig?.fees);
      });
    }
  }, [id]);

  return (
    <div>
      <h3> Reward coin price config </h3>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <FormControl style={{ width: '100%' }}>
            <InputLabel id="pool-label">Uniswap version</InputLabel>
            <Select
              label="Uniswap version"
              value={uniswapVersion}
              onChange={handleUniswapVersionChange}
              fullWidth
            >
              <MenuItem value="v2">v2</MenuItem>
              <MenuItem value="v3">v3</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={4}>
          <TextField
            label={uniswapVersion === 'v2' ? 'Router address' : 'Quoter address'}
            value={routerOrQuoterAddress}
            onChange={handleRouterOrQuoterAddressChange}
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <div style={{ marginBottom: '20px' }}>
            <h5>Path to WCRO (WPOL)</h5>
            <p>Example: REWARD_COIN, USDC, WCRO</p>
            <Button variant="contained"
              onClick={handleAddCoin}
              style={{ marginRight: '10px' }}
            >
              Add coin
            </Button>
            <Button variant="contained"
              onClick={() => handleRemoveCoin()}
            >
              Remove coin
            </Button>
          </div>

          {renderPathToWethInputs()}
        </Grid>

        {uniswapVersion === 'v3' && (
          <Grid item xs={12} style={{ marginTop: '20px' }}>
            <div style={{ marginBottom: '20px' }}>
              <h5>Fees</h5>
            </div>

            {renderFeesInputs()}
          </Grid>
        )}


        <Grid item xs={12} style={{ marginTop: '40px' }}>
          <div style={{ marginBottom: '10px' }}>
            <strong> * Reward price update every 12 hour </strong>
          </div>

          <Button type="submit" variant="contained" color="primary" onClick={handleSubmit}>
            Submit
          </Button>

          <Button type="submit" variant="contained" style={{ marginLeft: '10px' }} onClick={handleTry} disabled={loading}>
            {loading ? 'Loading...' : 'Try'}
          </Button>

          <span style={{ marginLeft: '10px' }}>
            1 REWARD_COIN = <span style={{ fontWeight: 'bold' }}>{pricePreview}</span> WCRO
          </span>

        </Grid>
      </Grid>

      <div style={{ marginTop: '80px' }} />
      <Detail />
    </div>
  );
};

function Detail() {
  const { id } = useParams();
  const [detail, setDetail] = useState({});
  const [loading, setLoading] = useState(false);

  async function calculateAPR() {
    setLoading(true);
    try {
      await stakingService.calculateAPR(id);
      toast.success("Success");
      await fetchDetail();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Fail to calculate APR");
    } finally {
      setLoading(false);
    }
  }

  async function fetchDetail() {
    if (!id) return;
    const { data } = await stakingService.detail(id);
    console.log(data);
    setDetail(data);
  }

  useEffect(() => {
    fetchDetail();
  }, [id]);

  return (
    <div>
      <h3> Detail </h3>
      <div style={{ marginBottom: '10px' }}>
        <strong> * APR update every 4 hour </strong>
      </div>

      <Button variant="contained"
        onClick={() => calculateAPR()}
        style={{ marginRight: '10px' }}
        disabled={loading}
      >
        {loading ? 'Loading...' : 'Calculate APR'}
      </Button>

      <ul>
        <li>Address: {detail.address}</li>
        <li>Name: {detail.name}</li>
        <li>Reward per week: {detail.rewardPerWeek} {detail.rewardCoinName}</li>
        <li>Reward coin: {detail.rewardCoin}</li>
        <li>Reward coin price: {detail.rewardCoinPrice} WCRO</li>
        <li>NFT Boost: {detail.boostRatio} %</li>
        <li>Booster address: {detail.boosterAddress}</li>
        <li> Collections detail:
          {detail.collectionsDetail?.map((collection, index) => (
            <ul key={index}>
              <li>Address: {collection.address}</li>
              <li>Ratio: {collection.ratio}</li>
              <li>NF price: {collection.nfPrice}</li>
              <li>Staked: {collection.staked}</li>
              <li>Additional staked from booster: {collection.additionalStakedFromBooster}</li>
              <li>Total staked: {collection.totalStaked}</li>
              <li>APR: {collection.APR} %</li>
              <li>Calculated APR at: {collection.calculatedAprAt}</li>
              <span> ------------------------------------- </span>
            </ul>
          ))}
        </li>
      </ul>
    </div>
  );
}
